<template>
  <div :class="{ 'form-group': exibeLabel }">
    <label v-if="exibeLabel"> {{ label }} </label>
    <BuscarSelecionar
      :id="id"
      :lista="guias"
      :selecionado="guia"
      :minimo="minimo"
      :exibir="['autorizacao.numeroGuia', 'beneficiario.nome']"
      :exibir-chave="false"
      @selecionar="selecionarGuia"
      @limpar="limparGuia"
      @recuperar="recuperarGuias"
    />
  </div>
</template>

<script>
import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import GuiaServico from '@/servicos/GuiaServico'

const guiaServico = new GuiaServico()

export default {
  name: 'BuscarSelecionarGuia',
  components: { BuscarSelecionar },
  props: {
    label: {
      type: String,
      default: 'Guia',
    },
    id: {
      type: String,
      default: 'guia',
    },
    minimo: {
      type: Number,
      default: 0,
    },
    exibeLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      guia: {},
      guias: [],
    }
  },
  methods: {
    selecionarGuia(guia) {
      this.$emit('selecionadoGuia', guia)
    },
    limparGuia() {
      this.guia = {}
      this.$emit('limparGuia')
    },
    recuperarGuias(filtro) {
      const data = {
        numero: filtro.palavra,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
        ativo: true,
      }
      guiaServico.recuperarTodos(data).then((result) => {
        this.guias = result.guias
      })
    },
  },
}
</script>
